/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */

import React from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import edm from '@bingads-webui-campaign-legacy/hotel-center-edm/index';
import jsData from '@bingads-webui-campaign-legacy/hotel-center-js-data/index';
import { SubAccountSelector } from './subaccount-selector';

export class SubaccountSelectorPanel extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      subAccounts: [],
      totalCount: 0,
      totalCountWithoutQuery: 0,
      isLoading: false,
      selectedSubaccountName: props.i18n.getString('HotelCenter_Subheader_All_SubAccount_Label'),
    };

    this.pageSize = 6;
  }

  componentDidMount() {
    this.fetchSubaccounts();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.selectedSubaccountId !== this.props.selectedSubaccountId) {
      this.fetchSubaccounts();
    }
  }
  onCreateNewClicked = () => {
    const { history } = this.props;
    history.push({
      pathname: '/campaign/vnext/hotelcenter/setup',
      search: history.location.search,
    });
  };

  getPlaceHolder = () => {
    const { subaccounts } = this.state;
    const { selectedSubaccountId, i18n } = this.props;
    let selectedSubaccountName = i18n.getString('HotelCenter_Subheader_All_SubAccount_Label');
    if (!selectedSubaccountId || selectedSubaccountId === 'selectAllSubAccount') {
      this.setState({ selectedSubaccountName });
      return;
    }
    let isFind = false;
    _.each(subaccounts, (item) => {
      if (item.Id === selectedSubaccountId) {
        selectedSubaccountName = item.Name;
        isFind = true;
      }
    });
    if (isFind || selectedSubaccountId === 'selectAllSubAccount') {
      this.setState({ selectedSubaccountName });
      return;
    }
    // eslint-disable-next-line consistent-return
    return jsData.SubAccount.find(selectedSubaccountId, { entitySet: edm.currentCustomer.SubAccounts })
      .then((subaccount) => {
        // navigate from assignment page to overview page will trigger getPlaceHolder twice, add this judgement to prevent continue execute when props change
        if (this.props.selectedSubaccountId !== selectedSubaccountId) {
          return;
        }
        selectedSubaccountName = subaccount.Name;
        this.setState({ selectedSubaccountName });
      });
  };

  transformQueryOptions = (params) => {
    const queryOptions = {
      where: {
        Status: {
          $eq: 'Active',
        },
      },
    };

    if (params && params.searchQuery) {
      queryOptions.where.Name = {
        $contains: params.searchQuery,
      };
    }

    if (params && params.pageNumber) {
      queryOptions.limit = params.pageSize;
      queryOptions.offset = params.pageNumber * params.pageSize;
    } else {
      queryOptions.limit = this.pageSize;
      queryOptions.offset = 0;
    }
    return queryOptions;
  };

  fetchSubaccounts = (params) => {
    const options = {
      entitySet: edm.currentCustomer.SubAccounts,
      cacheResponse: false,
    };
    const query = this.transformQueryOptions(params);
    this.setState({
      isLoading: true,
    });
    return jsData.SubAccount.findAll(query, options)
      .then((originalSubAccounts) => {
        this.updateSubAccounts(originalSubAccounts, params);
        this.getPlaceHolder();
      }).finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  };

  updateSubAccounts = (originalSubAccounts, params) => {
    if (originalSubAccounts && _.isArray(originalSubAccounts)) {
      const subAccounts = _.map(originalSubAccounts, subAccount => (
        {
          Id: subAccount.Id,
          Name: subAccount.Name,
          isDisabled: subAccount.Status !== 'Active',
        }
      ));
      if (params) {
        this.setState({
          subAccounts,
          totalCount: originalSubAccounts.totalCount,
        });
      } else {
        this.setState({
          subAccounts,
          totalCount: originalSubAccounts.totalCount,
          totalCountWithoutQuery: originalSubAccounts.totalCount,
        });
      }
    }
  };

  render() {
    const {
      i18n, onSubaccountChanged, classes, selectedSubaccountId,
    } = this.props;
    const {
      subAccounts,
      totalCount,
      totalCountWithoutQuery,
      isLoading,
      selectedSubaccountName,
    } = this.state;

    return (
      <div className={classes.SubAccountSelectorContainer}>
        <SubAccountSelector
          subaccounts={subAccounts}
          selectedSubaccountName={selectedSubaccountName}
          onSelectionChanged={onSubaccountChanged}
          onCreateNewClicked={this.onCreateNewClicked}
          i18n={i18n}
          selectedSubaccountId={selectedSubaccountId}
          totalCount={totalCount}
          pageSize={this.pageSize}
          onFetch={this.fetchSubaccounts}
          isMultiPage={totalCountWithoutQuery > this.pageSize}
          isLoading={isLoading}
        />
      </div>
    );
  }
}

SubaccountSelectorPanel.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  onSubaccountChanged: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    overviewPage: PropTypes.string,
  }).isRequired,
  selectedSubaccountId: PropTypes.string.isRequired,
};

